var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.horizontalWaterfall = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }
    setTimeout(function () {
        if (!metadata.KendoConfig) {
            metadata.KendoConfig = {};
        }

        metadata.KendoConfig.kendoType = 'horizontalWaterfall';
        
        MDB.Charts.renderers.waterfall(widget, chart, data, metadata);
    }, 0);
};